import makeStyles from "@material-ui/core/styles/makeStyles";
import { useState } from "react";
import { Button, TextField } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useDataLayerValue } from "../../Reducer/DataLayer";

import ReactQuill from "react-quill";
import parse from "html-react-parser";

const Contents = (props) => {
  const classes = useStyles();

  const [{ contents }, dispatch] = useDataLayerValue();

  const [news, setNews] = useState({
    content: "",
    content_index: -1,
  });

  // DELETE CONTENT
  const handleDelete = (index) => {
    dispatch({
      type: "DELETE_CONTENT",
      payload: { index },
    });
    setNews({
      ...news,
      content: news?.content_index === index ? "" : news.content,
      content_index:
        news?.content_index === index
          ? -1
          : news.content_index > index
          ? news.content_index - 1
          : news.content_index,
    });
  };

  // EDIT CONTENT
  const handleEdit = async (index) => {
    console.log("INDEX: ", index);
    setNews({
      ...news,
      content: contents[index],
      content_index: index,
    });
  };

  // SAVE CONTENT
  const handleSave = async () => {
    await dispatch({
      type: "ADD_CONTENT",
      payload: { index: news.content_index, content: news.content },
    });
    setNews({
      ...news,
      content: "",
      content_index: -1,
    });
  };

  console.log("A :", contents);
  console.log("B :", news?.content);
  console.log("C :", news?.content_index);

  return (
    <div className={classes.root}>
      <h3 className="text-center">List of Content</h3>
      <ul className="list-unstyled">
        {contents?.map((content, index) => {
          return (
            <li className={classes.content} key={index}>
              <div className={classes.content_text}>{parse(content)}</div>
              <div className={classes.content_icons}>
                <EditIcon
                  variant="contained"
                  size="small"
                  className={classes.editIcon}
                  onClick={() =>
                    // handleEdit(index)
                    setNews({
                      ...news,
                      content: content,
                      content_index: index,
                    })
                  }
                />
                <DeleteIcon
                  variant="contained"
                  size="small"
                  className={classes.deleteIcon}
                  onClick={() => handleDelete(index)}
                />
              </div>
            </li>
          );
        })}
      </ul>
      <div className="py-3 d-grid">
        {/* <TextField
          label="Content"
          variant="filled"
          className=""
          placeholder="Enter Content"
          multiline
          value={news?.content}
          onChange={(e) => setNews({ ...news, content: e.target.value })}
        /> */}
        <ReactQuill
          placeholder="Enter Content"
          value={news?.content}
          onChange={(value) => setNews({ ...news, content: value })}
          theme="snow"
          style={{
            width: "inherit",
            overflow: "hidden",
            border: "1px #868 solid",
          }}
        />

        <Button
          variant="contained"
          color="primary"
          size="small"
          className="mx-auto my-2"
          startIcon={<SaveIcon />}
          onClick={handleSave}
          disabled={!news?.content}
        >
          {/* {news?.content_index !== -1 ? "Save" : "Update"}  */}
          Save Content
        </Button>
      </div>
    </div>
  );
};

export default Contents;

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.5rem",
    margin: "1rem 0.125rem",
    padding: "1rem",
    backgroundColor: "#f2f4fc",
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
    margin: "0.25rem 0",
  },
  content_text: {
    alignSelf: "center",
    backgroundColor: "#d2d4d9",
    borderRadius: "0.25rem",
    flex: 1,
    margin: "0 .425rem 0 0.25rem",
    padding: "0.25rem 0.5rem",
    width: "inherit",
    overflow: "hidden",
    overflowWrap: "break-word",
  },
  content_icons: {
    alignSelf: "center",
    display: "flex",
  },
  editIcon: {
    color: "#0080ff",
    cursor: "pointer",
    margin: "0.25rem",
  },
  deleteIcon: {
    color: "#ff0040",
    margin: "0.25rem",
    cursor: "pointer",
  },
}));
